export default function lightbox(element: HTMLElement) {
  const imageElement = element.querySelector(
    '.lightbox__image',
  ) as HTMLImageElement;
  const closeButton = element.querySelector('.lightbox__close');
  const prevButton = element.querySelector(
    '.lightbox__navPrev',
  ) as HTMLButtonElement;
  const nextButton = element.querySelector(
    '.lightbox__navNext',
  ) as HTMLButtonElement;

  let currentIndex = 0;
  let images: Array<{ src: string; alt: string }> = [];

  // Open lightbox with specific image
  function open(
    index: number,
    imagesList: Array<{ src: string; alt: string }>,
  ) {
    images = imagesList;
    currentIndex = index;
    showImage(currentIndex);
    element.classList.add('lightbox--active');
  }

  // Close lightbox
  function close() {
    element.classList.remove('lightbox--active');
  }

  // Show image at specific index
  function showImage(index: number) {
    if (!images[index]) return;

    imageElement.src = images[index].src;
    imageElement.alt = images[index].alt;

    // Update navigation buttons
    if (prevButton) {
      prevButton.disabled = index === 0;
    }
    if (nextButton) {
      nextButton.disabled = index === images.length - 1;
    }
  }

  // Navigate to previous image
  function showPrevious() {
    if (currentIndex > 0) {
      currentIndex--;
      showImage(currentIndex);
    }
  }

  // Navigate to next image
  function showNext() {
    if (currentIndex < images.length - 1) {
      currentIndex++;
      showImage(currentIndex);
    }
  }

  // Close button click
  closeButton?.addEventListener('click', close);

  // Navigation buttons
  prevButton?.addEventListener('click', showPrevious);
  nextButton?.addEventListener('click', showNext);

  // Close on background click
  element.addEventListener('click', (e) => {
    if (e.target === element) {
      close();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!element.classList.contains('lightbox--active')) return;

    switch (e.key) {
      case 'Escape':
        close();
        break;
      case 'ArrowLeft':
        showPrevious();
        break;
      case 'ArrowRight':
        showNext();
        break;
    }
  });

  // Expose open method for external use
  // biome-ignore lint/suspicious/noExplicitAny: allow any for lightboxOpen
  (element as any).lightboxOpen = open;
}
